import { Link, useLocation } from "react-router-dom";
import { useAuth } from "@/hooks/useAuth";

const bottomNavItems = [
  { label: "Home", path: "/", icon: "ri-home-5-line", activeIcon: "ri-home-5-fill" },
  { label: "Shop", path: "/usa-shop", icon: "ri-store-2-line", activeIcon: "ri-store-2-fill" },
  { label: "Wholesale", path: "/wholesale", icon: "ri-ship-line", activeIcon: "ri-ship-fill" },
  { label: "Social", path: "/social", icon: "ri-compass-3-line", activeIcon: "ri-compass-3-fill" },
  { label: "Account", path: "/auth", icon: "ri-user-3-line", activeIcon: "ri-user-3-fill" },
];

export default function MobileBottomNav() {
  const location = useLocation();
  const { isLoggedIn } = useAuth();

  const accountPath = isLoggedIn ? "/dashboard" : "/auth";

  return (
    <nav className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-gray-100" style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      <div className="flex items-stretch h-16">
        {bottomNavItems.map((item) => {
          const path = item.label === "Account" ? accountPath : item.path;
          const isActive = location.pathname === item.path || (item.label === "Account" && (location.pathname === "/auth" || location.pathname === "/dashboard"));

          return (
            <Link
              key={item.label}
              to={path}
              className="flex-1 flex flex-col items-center justify-center gap-0.5 cursor-pointer transition-all active:scale-95"
            >
              {/* Active indicator bar */}
              <div
                className="absolute top-0 h-0.5 w-8 rounded-full transition-all duration-300"
                style={{
                  background: isActive ? "linear-gradient(to right, #B8860B, #FFD700)" : "transparent",
                }}
              />
              <div className={`w-6 h-6 flex items-center justify-center transition-colors`}>
                <i
                  className={`text-xl ${isActive ? item.activeIcon : item.icon}`}
                  style={{ color: isActive ? "#B8860B" : "#9ca3af" }}
                />
              </div>
              <span
                className="text-xs font-semibold transition-colors"
                style={{ color: isActive ? "#B8860B" : "#9ca3af" }}
              >
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
